'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactstrap = require('reactstrap');

require('./btn.css');

var _ = require('../../');

var _2 = require('../');

var _models = require('../../models');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GeckoBtn = function (_Component) {
    _inherits(GeckoBtn, _Component);

    function GeckoBtn() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, GeckoBtn);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GeckoBtn.__proto__ || Object.getPrototypeOf(GeckoBtn)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            disabled: false
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(GeckoBtn, [{
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {
            this.btnId = this.props.id ? this.props.id : _.GECKO_UTILS.generateUniqueId();
        }
    }, {
        key: 'renderId',
        value: function renderId() {
            return 'gecko-ui-btn-' + this.btnId;
        }
    }, {
        key: 'preparePreset',
        value: function preparePreset(key) {
            if (this.props.preset && _.GECKO_CONSTS.BTN_PRESETS[this.props.preset] && _.GECKO_CONSTS.BTN_PRESETS[this.props.preset][key]) {
                return _.GECKO_CONSTS.BTN_PRESETS[this.props.preset][key];
            }
            return null;
        }

        // Prepare class name

    }, {
        key: 'prepareClass',
        value: function prepareClass() {
            var type = this.props.type || this.preparePreset('type') || _.GECKO_CONSTS.BTN_TYPE_DEFAULT;
            return _.GECKO_CONSTS.BTN_CLASSES[type];
        }
    }, {
        key: 'prepareIcon',
        value: function prepareIcon() {
            return this.props.icon || this.preparePreset('icon');
        }

        // Render button name

    }, {
        key: 'renderName',
        value: function renderName() {
            return this.props.name || this.preparePreset('name') || null;
        }
    }, {
        key: 'renderAriaLabel',
        value: function renderAriaLabel() {
            return this.props.ariaLabel || this.preparePreset('ariaLabel') || null;
        }

        // Render button class

    }, {
        key: 'renderClass',
        value: function renderClass() {
            var _GECKO_UTILS$classNam;

            return _.GECKO_UTILS.classNames((_GECKO_UTILS$classNam = {}, _defineProperty(_GECKO_UTILS$classNam, 'gecko-ui-btn btn', true), _defineProperty(_GECKO_UTILS$classNam, this.prepareClass(), true), _defineProperty(_GECKO_UTILS$classNam, 'btn-' + this.props.size, this.props.size), _defineProperty(_GECKO_UTILS$classNam, this.props.className, this.props.className), _GECKO_UTILS$classNam));
        }
    }, {
        key: 'renderIcon',
        value: function renderIcon() {
            if (this.props.icon || this.preparePreset('icon')) {
                var classes = [this.prepareIcon()];
                if (this.renderName()) classes.push('mr-1');
                return _react2.default.createElement(_2.GeckoIcon, Object.assign({ icon: '' + classes.join(' ') }, this.props.iconProps));
            }
            return null;
        }
    }, {
        key: 'renderSrOnly',
        value: function renderSrOnly() {
            if (!this.renderName() && this.renderAriaLabel()) {
                return _react2.default.createElement(
                    'span',
                    { className: 'sr-only' },
                    this.renderAriaLabel()
                );
            }
            return null;
        }
    }, {
        key: 'renderTooltip',
        value: function renderTooltip() {
            if (this.props.tooltip) {
                //Determine what tooltp to show (defaults to button name)
                if (typeof this.props.tooltip === 'string') {
                    this.tooltip = this.props.tooltip;
                } else if (this.props.name) {
                    this.tooltip = this.props.name;
                }

                return _react2.default.createElement(
                    _reactstrap.UncontrolledTooltip,
                    { delay: 0, placement: 'top', target: this.renderId() },
                    this.tooltip
                );
            }
            return null;
        }
    }, {
        key: 'isDisabled',
        value: function isDisabled() {
            return this.state.disabled || (this.props.disabledWhen ? this.props.disabledWhen() : false);
        }
    }, {
        key: 'handler',
        value: function handler() {
            var _this2 = this;

            var handler = this.props.handler();

            // If promise is returned disable button
            if (handler && handler instanceof Promise) {
                // Disable button
                this.setState({ disabled: true });
                // Undisable button after promise has resolved or rejected
                return handler.then(function () {
                    return _this2.setState({ disabled: false });
                }).catch(function () {
                    return _this2.setState({ disabled: false });
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'button',
                Object.assign({
                    type: 'button',
                    role: 'button'
                }, this.props, {
                    'aria-label': this.props.ariaLabel || this.renderName(),
                    id: this.renderId(),
                    className: this.renderClass(),
                    onClick: this.handler.bind(this),
                    disabled: this.isDisabled() }),
                this.renderIcon(),
                this.renderName(),
                this.renderSrOnly(),
                this.renderTooltip()
            );
        }
    }]);

    return GeckoBtn;
}(_react.Component);

GeckoBtn.defaultProps = {
    handler: function handler() {},
    iconProps: {}
};

GeckoBtn.propTypes = _models.GeckoBtnModel;

exports.default = GeckoBtn;